<template>
  <div class="main-container">
    <!-- Navbar section -->
    <Header :main="true" />

    <!-- hero section -->
    <Hero class="hero-sass" />

    <!-- Gradation section start -->
    <div
      class="icon-process-area section-space--pt_120 section-space--pb_120"
      id="about"
    >
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <Gradation />
          </div>
        </div>
      </div>
    </div>

    <!-- faq banner start -->
    <FaqBanner />

    <BannerOne class="banner-one-sass" />

    <!--
		<CurveShape class="curve-bottom">
        <template v-slot:bgcolor>
            <path style="fill: #f6f5f9;
                stroke-miterlimit:10;" 
                d="M3360.5,97.739c-242,0-480-48.375-480-48.375
                    S2647.5,0.5,2400.5,0.5s-480,48.375-480,48.375s-238,48.864-480,48.864s-480-48.375-480-48.375S727.5,0.5,480.5,0.5
                    S0.5,48.875,0.5,48.875V108h1920h1920V48.875C3840.5,48.875,3602.5,97.739,3360.5,97.739z"/>
        </template>
    </CurveShape>
    <CtaOne />
    -->

    <!-- sass feature component -->
    <SassFeature class="gray-gradient" id="service" />

    <!-- testimonial section -->
    <!--
    <div class="testimonial-slider-area section-space--ptb_120 bg-gray" id="testimonial">
      <div class="container">
        <div class="section-title text-center section-space--mb_60">
          <h2 class="section-title font-weight--light wow move-up">Don’t take our word for it</h2>
        </div>
        <TestimonialTwo />
      </div>
    </div>
    -->

    

    

    <div
      class="pricing-table-area section-space--pt_120 section-space--pb_120 position-relative"
      id="pricing"
    >
      <div
        class="pricing-table-title-area position-relative section-table_gradeient"
      >
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div
                class="section-title-wrapper text-center section-space--mb_60"
              >
                <h2 class="section-title font-width-light mb-15 wow move-up">
                  Pricing that fits your business
                </h2>
                <p class="wow move-up">
                  Choose a suitable package for your site
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="pricing-table-content-area">
        <div class="container">
          <Pricing />
        </div>
      </div>
    </div>
    <!-- banner component -->
    <BannerBgOne />

    <Contact id="contact" />

    <!-- footer section -->
    <Footer />

    <cookie-law theme="dark-lime" buttonClass="btn btn-green">
      <div slot="message">
        This website uses cookies. See our
        <router-link :to="{ path: 'terms' }">Terms of Use</router-link> and
        <router-link :to="{ path: 'privacy' }">Privacy Policy</router-link>
        for more information.
      </div>
    </cookie-law>
  </div>
</template>

<script>
import CookieLaw from "vue-cookie-law";

import Header from "../components/Header";
import Hero from "../components/Hero";
import Gradation from "../components/Gradation";
import FaqBanner from "../components/FaqBanner";
import BannerOne from "../components/BannerOne";
import SassFeature from "../components/SassFeature";
import BannerBgOne from "../components/BannerBgOne";
import Footer from "../components/Footer";
import Pricing from "../components/Pricing";
import Contact from "../components/Contact";
import CtaOne from "../components/CtaOne";
import CurveShape from "../components/CurveShape";

export default {
  name: "app",
  components: {
    CookieLaw,
    Header,
    Hero,
    Gradation,
    FaqBanner,
    BannerOne,
    SassFeature,
    BannerBgOne,
    Footer,
    Pricing,
    Contact,
    CtaOne,
    CurveShape,
  },
};
</script>